import { bunja } from 'bunja';

import { spotMarketsAtom } from './internal/fixed-topics/spot-market';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/spot-market';

export const spotMarketsBunja = bunja(() => {
  bunja.use(r230522SocketBunja);
  return { spotMarketsAtom };
});
spotMarketsBunja.debugLabel = 'spotMarketsBunja';
